import { Grid, Text } from '@farmersdog/corgi-x';

import { HeadingText } from '../HeadingText';
import { MAX_SELECTED_RECIPES } from '../RecipesSelection';
import styles from '../RecipesSelection.module.css';

interface TopSectionProps {
  petName: string;
  hasMultipleRecommendedRecipes: boolean;
}

export const TopSection = ({
  petName,
  hasMultipleRecommendedRecipes,
}: TopSectionProps) => {
  return (
    <>
      <HeadingText
        header={`Build ${petName}’s Plan`}
        subheader={`Choose up to ${MAX_SELECTED_RECIPES} Recipes`}
      />

      <Grid justifyContent={'center'}>
        <Text
          className={styles.recipesCopy}
          variant="article-12"
          align={'center'}
        >
          The recipe{hasMultipleRecommendedRecipes && 's'} we picked{' '}
          {hasMultipleRecommendedRecipes ? 'are' : 'is'} most popular for dog
          profiles similar to {petName}’s, but all the options below are
          recommended.
        </Text>
      </Grid>
    </>
  );
};
